<template>
    <div class="row h-100">
        <div class="col-12 d-none d-md-block col-md-5">
            <div class="left__auth_block">
                <a class="header__logo" :href="homelink">
                    <img src="/img/logo_white.png" alt="">
                </a>
                <h2 class="mb-4">{{ get_translation_constant('text_has_account') }}</h2>
                <a class="btn btn__medium btn__black mb-4"
                   :href="loginlink">{{ get_translation_constant('text_entry_account') }}</a>
                <p>{{ get_translation_constant('text_to_place_order') }}</p>
            </div>
        </div>
        <div class="col-12 col-md-6 offset-md-1 col-lg-5 offset-lg-2">
            <h2>{{ get_translation_constant('text_personal_data') }}</h2>
            <form>
                <div class="form__col">
                    <label>{{ get_translation_constant('text_firstname_lastname_cyrillic') }}<sup>*</sup></label>
                    <div class="row">
                        <div class="col-6 form__col" :class="hasError('first_name')">
                            <input v-model="form.first_name" class="form__control"
                                   name="name_en" type="text"
                                   :placeholder="get_translation_constant('text_your_firstname')">

                            <div class="form__error" v-if="hasErrorMessage('first_name')">
                                {{ hasErrorMessage('first_name') }}
                            </div>
                        </div>
                        <div class="col-6 form__col" :class="hasError('last_name')">
                            <input v-model="form.last_name" class="form__control" id="surname_en"
                                   name="surname_en" type="text"
                                   :placeholder="get_translation_constant('text_your_lastname')">

                            <div class="form__error" v-if="hasErrorMessage('last_name')">
                                {{ hasErrorMessage('last_name') }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form__col">
                    <label>{{ get_translation_constant('text_firstname_lastname_latin') }}<sup>*</sup></label>
                    <div class="row">
                        <div class="col-6 form__col" :class="hasError('first_name_latin')">
                            <input v-model="form.first_name_latin" class="form__control" id="name_ro"
                                   name="name_ro" type="text"
                                   :placeholder="get_translation_constant('text_your_firstname')">

                            <div class="form__error" v-if="hasErrorMessage('first_name_latin')">
                                {{ hasErrorMessage('first_name_latin') }}
                            </div>
                        </div>

                        <div class="col-6 form__col" :class="hasError('last_name_latin')">
                            <input v-model="form.last_name_latin" class="form__control" id="surname_ro"
                                   name="surname_ro" type="text"
                                   :placeholder="get_translation_constant('text_your_lastname')">

                            <div class="form__error" v-if="hasErrorMessage('last_name_latin')">
                                {{ hasErrorMessage('last_name_latin') }}
                            </div>
                        </div>
                    </div>
                </div>


                <div class="form__col">
                    <div class="row">
                        <div class="col-6 form__col" :class="hasError('patronymic')">

                            <label>{{
                                    get_translation_constant('text_patronymic')
                                }}<sup>*</sup></label>
                            <input class="form__control"
                                   :placeholder="get_translation_constant('text_patronymic')"
                                   type="text"
                                   v-model="form.patronymic">
                            <div class="form__error" v-if="hasErrorMessage('patronymic')">
                                {{ hasErrorMessage('patronymic') }}
                            </div>
                        </div>
                        <div class="col-6 form__col" :class="hasError('birthday')">
                            <label>{{
                                    get_translation_constant('text_birthday')
                                }}<sup>*</sup></label>

                            <date-picker v-model="form.birthday"
                                         class="form__control"
                                         @dp-hide="showDatePicker"
                                         :locale="lng"
                                         :config="{format:'DD-MM-YYYY', locale:lng}"></date-picker>
                            <div class="form__error" v-if="hasErrorMessage('birthday')">
                                {{ hasErrorMessage('birthday') }}
                            </div>
                        </div>
                    </div>

                </div>
                <div class="form__col" :class="hasError('gender_id')">
                    <label>{{ get_translation_constant('text_sex') }}<sup>*</sup></label>
                    <div class="row no-gutters radio_group__custom">

                        <div v-for="(gender, index) in genders" class="col-auto radio_group__item">
                            <input v-model="form.gender_id" :id="gender.title" name="sex" type="radio"
                                   :value="gender.id">
                            <label :for="gender.title">{{ gender.title }}</label>
                        </div>
                        <!-- <div class="col-auto radio_group__item">
                             <input v-model="form.sex" id="male" name="sex" type="radio" value="male">
                             <label for="male">{{ get_translation_constant('text_male') }}</label>
                         </div>
                         <div class="col-auto radio_group__item">
                             <input v-model="form.sex" id="female" name="sex" type="radio" value="female">
                             <label for="female">{{ get_translation_constant('text_female') }}</label>
                         </div>-->
                    </div>
                    <div class="form__error" v-if="hasErrorMessage('gender_id')">
                        {{ hasErrorMessage('gender_id') }}
                    </div>
                </div>


                <div class="form__col" :class="hasError('city_ref')">
                    <label>{{
                            get_translation_constant('text_your_city')
                        }}<sup>*</sup></label>
                    <multiselect v-model="form.city_ref"
                                 class="form-control"
                                 :multiple="false"
                                 :placeholder="get_translation_constant('text_enter_street_in_ukraine_letters')"
                                 :options="novaPoshtaCities"
                                 label="Description"
                                 selectLabel=""
                                 deselectLabel=""
                                 :optionHeight="48"
                                 :showPointer="true"
                                 @search-change="asyncCities"
                                 @select="loadStreets"
                    >
                    </multiselect>
                    <div class="form__error"
                         v-if="hasErrorMessage('city_ref')">
                        {{ get_translation_constant('text_field_is_required') }}
                    </div>
                </div>
                <div class="form__col" :class="hasError('street')">
                    <label>{{
                            get_translation_constant('text_delivery_street')
                        }}<sup>*</sup></label>
                    <multiselect v-model="form.street"
                                 class="form-control"
                                 :multiple="false"
                                 :placeholder="get_translation_constant('text_enter_street_in_ukraine_letters')"
                                 :options="form.streets"
                                 label="Description"
                                 selectLabel=""
                                 deselectLabel=""
                                 :optionHeight="48"
                                 :showPointer="true"
                                 @search-change="searchTimeOut"
                    >
                    </multiselect>
                    <div class="form__error"
                         v-if="hasErrorMessage('deliveryMethod.novaPoshta.street')">
                        {{ get_translation_constant('text_field_is_required') }}
                    </div>
                </div>

                <div class="form__col">
                    <div class="row">
                        <div class="col-6 form__col" :class="hasError('buildingNumber')">
                            <label for="buildingNumber">{{
                                    get_translation_constant('text_choose_house')
                                }}<sup>*</sup></label>
                            <input v-model="form.buildingNumber" class="form__control" id="buildingNumber"
                                   name="buildingNumber"
                                   type="text"
                                   :placeholder="get_translation_constant('text_choose_house')">

                            <div class="form__error" v-if="hasErrorMessage('buildingNumber')">
                                {{ hasErrorMessage('buildingNumber') }}
                            </div>
                        </div>
                        <div class="col-6">
                            <label for="flat">{{
                                    get_translation_constant('text_your_flat')
                                }}</label>
                            <input v-model="form.flat" class="form__control" id="flat" name="flat"
                                   type="text"
                                   :placeholder="get_translation_constant('text_enter_flat')">
                        </div>
                    </div>
                </div>

                <div class="form__col" :class="hasError('postcode')">
                    <label for="postcode">{{
                            get_translation_constant('text_your_postcode')
                        }}<sup>*</sup></label>
                    <input v-model="form.postcode" class="form__control" id="postcode" name="postcode"
                           type="text"
                           :placeholder="get_translation_constant('text_enter_postcode')">
                    <div class="form__error" v-if="hasErrorMessage('postcode')">
                        {{ hasErrorMessage('postcode') }}
                    </div>
                </div>

                <div class="form__col" :class="hasError('phone_number')">
                    <label>{{ get_translation_constant('text_phone') }}<sup>*</sup></label>
                    <div class="phone__block">
                        <multiselect v-model="form.phone_prefix"
                                     class="form-control"
                                     :multiple="false"
                                     :placeholder="''"
                                     :options="locationPrefixes"
                                     label="title"
                                     selectLabel=""
                                     deselectLabel=""
                                     :optionHeight="48"
                                     :showPointer="true"
                                     :searchable="false"
                        >
                            <template slot="singleLabel" slot-scope="props">
                                <img class="option__image" :src="props.option.image" width="16">
                                <span class="option__title">{{ props.option.title }}</span>
                            </template>
                            <template slot="option" slot-scope="props">
                                <img class="option__image" :src="props.option.image" width="16">
                                <span class="option__title">{{ props.option.title }}</span>
                            </template>
                        </multiselect>
                        <input class="form__control type_tel" v-model="form.phone_number" type="tel">
                    </div>
                    <div class="form__error" v-if="hasErrorMessage('phone_number')">
                        {{ hasErrorMessage('phone_number') }}
                    </div>
                </div>

                <div class="form__col" :class="hasError('token')">
                    <div class="form__error" v-if="hasErrorMessage('token')">
                        Token Error!
                    </div>
                </div>
                <div class="form__col" :class="hasError('server')">
                    <div class="form__error" v-if="hasErrorMessage('server')">
                        Server Error!
                    </div>
                </div>

                <div class="form__col form__col_last d-flex justify-content-between align-items-center">
                    <button class="btn btn__medium btn__green" @click.prevent="accountAcceptRegistration()">
                        {{ get_translation_constant('text_accept') }}
                    </button>
                </div>
            </form>
        </div>

        <div class="col-12 d-md-none col-md-5 mt-5">
            <h5>{{ get_translation_constant('text_has_account') }}</h5>
            <p><a :href="loginlink">{{ get_translation_constant('text_entry_account') }}</a>, {{
                    get_translation_constant('text_to_place_order')
                }}</p>
        </div>
    </div>
</template>

<script>
export default {
    name: "Register",
    data() {
        return {
            errors: [],
            form: {
                locale: '',
                email: '',
                first_name: '',
                last_name: '',
                first_name_latin: '',
                last_name_latin: '',
                phone_prefix: '',
                phone_number: '',
                city_id: '',
                city: {
                    id: '',
                    title: ''
                },
                city_ref: null,
                novaPoshtaCities: [],
                gender_id: '',
                patronymic: '',
                birthday: '',
                buildingNumber: '',
                flat: '',
                street: '',
                streets: [],
                postcode: ''
            },
            timer: null,
            novaPoshtaCities: [],
            locationPrefixes: [],
        }
    },
    props: {
        email: {
            type: [String]
        },
        translations: {
            type: [Object, Array]
        },
        lng: {
            type: [String]
        },
        mainlng: {
            type: [String]
        },
        loginlink: {
            type: [String]
        },
        redirect: {
            type: [String]
        },
        registerlink: {
            type: [String]
        },
        accoutaddresslink: {
            type: [String]
        },
        accoutacceptlink: {
            type: [String]
        },
        homelink: {
            type: [String]
        },
        accoutaddressredirectlink: {
            type: [String]
        },
        accoutacceptredirectlink: {
            type: [String]
        },
        cities: {
            type: [Object, Array]
        },
        genders: {
            type: [Object, Array]
        },
        novaposhtacitysearchlink: {
            type: [String]
        },
        novaposhtastreetsearchlink: {
            type: [String]
        },
        nodeid: {
            type: [String, Boolean]
        },
        locations: {
            type: [Object, Array]
        },

    },
    methods: {
        asyncCities(query) {
            if (query === '') {
                return;
            }
            axios.post(this.novaposhtacitysearchlink, {
                find_city: query
            }).then(response => {
                this.novaPoshtaCities = response.data
            });
        },
        loadStreets() {
            setTimeout(() => {
                axios.post(this.novaposhtastreetsearchlink, {
                    street_ref: this.form.city_ref.Ref,
                    find_street: ''
                }).then(response => {
                    this.form.streets = response.data
                });

            }, 500)
        },
        showDatePicker(tytr) {

        },
        get_translation_constant(key) {
            return this.translations.filter((item) => {
                return item.key === key
            })[0]['value'][this.lng]
        },
        accountAddress() {
            window.location.replace(this.accoutaddressredirectlink);
            window.location.href = this.accoutaddressredirectlink;
        },
        accountAcceptRegistration() {
            let dataSubmit =  Object.assign({}, this.form);
            dataSubmit.phone_prefix = this.form.phone_prefix.title;
            axios.post(this.accoutacceptlink, dataSubmit).then(response => {
                console.log(response.status, response.data)
                if (response.status === 200) {
                    //set cookie access_token
                    this.$cookies.set('access_token', response.data['access_token'], response.data['expired_at'])
                    window.location.replace(this.accoutacceptredirectlink);
                    window.location.href = this.accoutacceptredirectlink;
                }
            }).catch(error => {
                console.log(error.response.data.errors)
                if (error.response.status === 400) {
                    this.errors = error.response.data.errors;
                }
                if (error.response.status === 422) {
                    this.errors = error.response.data.errors;
                }
                if (error.response.status === 500) {
                    this.errors = error.response.data.errors;
                }
            });
        },
        hasError(error) {
            if (this.errors[error])
                return 'has__error';
        },

        hasErrorMessage(error) {
            if (this.errors[error])
                return this.errors[error][0];

        },

        asyncFind(query) {
            axios.post(this.novaposhtacitysearchlink, {
                find_city: query
            }).then(response => {
                this.novaPoshtaCities = response.data
            });
        },
        searchTimeOut(query) {
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
                this.searchChange = false;
            }
            this.searchChange = true;
            this.timer = setTimeout(() => {
                this.asyncFind(query)
            }, 1000);
        },
    },
    computed: {},
    created() {
        this.locationPrefixes = Object.values(this.locations.filter((location) => {
            return location.id === parseInt(this.nodeid)
        })).map((location) => {
            return {
                image: location.image,
                title: location.phone_prefix
            };
        })
    },
    mounted() {
        this.form.locale = this.lng;
        this.form.email = this.email;

        this.form.phone_prefix = this.locationPrefixes.find((option) => {
            return option.location_id === parseInt(this.nodeid);
        });
        if (typeof this.form.phone_prefix == 'undefined') {
            this.form.phone_prefix = this.locationPrefixes[0]
        }
    },
    watch: {
        'form.phone_number': {
            handler(val, oldval) {
                //ua, az
                if ([1, 4].includes(parseInt(this.nodeid))) {
                    if ((val.length) > 9) {
                        this.form.phone_number = oldval;
                    }
                    return;
                }
                //md, bz
                if ((val.length) > 8) {
                    this.form.phone_number = oldval;
                }

            }
        }
    }
}
</script>

<style scoped>

</style>
